// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f88acc7","455":"ed39615c","977":"526e8c32"}[chunkId] + ".chunk.js";
};